(function () {
  function initColorVariants(root) {
    if (!root || root.dataset.nazvaColorVariantsReady === 'true') return;

    const track = root.querySelector('[data-nazva-color-variants-track]');

    if (!track) return;

    root.dataset.nazvaColorVariantsReady = 'true';

    const progress = root.querySelector('[data-nazva-color-variants-progress]');
    const maxScrollLeft = () => Math.max(0, track.scrollWidth - track.clientWidth);
    const clamp = (value) => Math.min(Math.max(value, 0), maxScrollLeft());

    const updateState = () => {
      root.classList.toggle('is-scrollable', maxScrollLeft() > 2);
      root.classList.toggle('is-at-end', track.scrollLeft >= maxScrollLeft() - 2);
      root.classList.toggle('is-at-start', track.scrollLeft <= 2);
      // прогресс-бар под лентой: заполнение = доля уже показанной ленты (видимая часть + прокрутка)
      if (progress) {
        const total = track.scrollWidth || 1;
        progress.style.width = Math.min(100, ((track.scrollLeft + track.clientWidth) / total) * 100).toFixed(2) + '%';
      }
    };

    // NAZVA Ops 2026-09-08: карточки - ссылки; на десктопе нативный drag ссылки/картинки обрывал pointer-события,
    // и протянуть ленту мышью было нельзя (та же грабля, что у ленты подкатегорий в августе).
    track.addEventListener('dragstart', (event) => event.preventDefault());
    track.querySelectorAll('a, img').forEach((el) => { el.draggable = false; });
    track.addEventListener('scroll', updateState, { passive: true });

    let isDragging = false;
    let hasMoved = false;
    let startX = 0;
    let startScrollLeft = 0;
    let previousX = 0;
    let previousTime = 0;
    let velocity = 0;
    let momentumFrame;
    let suppressNextClick = false;
    let suppressClickTimer;
    const dragThreshold = 6;

    const stopMomentum = () => {
      window.cancelAnimationFrame(momentumFrame);
      momentumFrame = undefined;
    };

    const runMomentum = () => {
      if (Math.abs(velocity) < 0.04) {
        updateState();
        return;
      }

      const previousScrollLeft = track.scrollLeft;
      track.scrollLeft = clamp(track.scrollLeft - velocity * 28);
      velocity *= 0.97;

      if (track.scrollLeft === previousScrollLeft) {
        updateState();
        return;
      }

      momentumFrame = window.requestAnimationFrame(runMomentum);
    };

    track.addEventListener('pointerdown', (event) => {
      if (event.target.closest('button, input, select, textarea')) return;
      // NAZVA Ops 2026-09-08: на тач-экранах ленту крутит нативный скролл (iOS запинался, когда JS перехватывал первое касание)
      if (event.pointerType !== 'mouse') return;

      stopMomentum();
      isDragging = true;
      hasMoved = false;
      startX = event.clientX;
      startScrollLeft = track.scrollLeft;
      previousX = event.clientX;
      previousTime = performance.now();
      velocity = 0;
    });

    track.addEventListener('pointermove', (event) => {
      if (!isDragging) return;

      const moved = event.clientX - startX;

      if (Math.abs(moved) > dragThreshold) {
        hasMoved = true;
      }

      if (!hasMoved) return;

      event.preventDefault();

      if (!track.hasPointerCapture(event.pointerId)) {
        track.setPointerCapture(event.pointerId);
      }

      const now = performance.now();
      const deltaX = event.clientX - previousX;
      const deltaTime = now - previousTime || 16;

      track.classList.add('is-dragging');
      track.scrollLeft = startScrollLeft - moved;
      velocity = deltaX / deltaTime;
      previousX = event.clientX;
      previousTime = now;
    });

    const stopDragging = (event) => {
      if (!isDragging) return;

      isDragging = false;
      track.classList.remove('is-dragging');

      if (track.hasPointerCapture(event.pointerId)) {
        track.releasePointerCapture(event.pointerId);
      }

      if (!hasMoved) {
        velocity = 0;
        updateState();
        return;
      }

      suppressNextClick = true;
      window.clearTimeout(suppressClickTimer);
      suppressClickTimer = window.setTimeout(() => {
        suppressNextClick = false;
      }, 300);
      runMomentum();
    };

    track.addEventListener('pointerup', stopDragging);
    track.addEventListener('pointercancel', stopDragging);
    track.addEventListener('pointerleave', stopDragging);

    track.addEventListener(
      'click',
      (event) => {
        if (!suppressNextClick) return;

        event.preventDefault();
        event.stopPropagation();
        suppressNextClick = false;
        window.clearTimeout(suppressClickTimer);
      },
      true
    );

    track.addEventListener(
      'wheel',
      (event) => {
        if (maxScrollLeft() <= 2) return;

        const scrollDelta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
        if (scrollDelta === 0) return;

        event.preventDefault();
        stopMomentum();
        track.scrollTo({
          left: clamp(track.scrollLeft + scrollDelta),
          behavior: 'smooth',
        });
      },
      { passive: false }
    );

    window.addEventListener('resize', updateState);
    updateState();
  }

  function initAll() {
    document.querySelectorAll('[data-nazva-color-variants]').forEach(initColorVariants);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-nazva-color-variants]').forEach(initColorVariants);
  });
})();
